import { render } from "./FooterPagina.vue?vue&type=template&id=62549cbc&scoped=true&ts=true"
import script from "./FooterPagina.vue?vue&type=script&lang=ts"
export * from "./FooterPagina.vue?vue&type=script&lang=ts"

import "./FooterPagina.vue?vue&type=style&index=0&id=62549cbc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\leonardo.wolber\\Documents\\GitHub\\LimaTec\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62549cbc"]])

export default __exports__